import { Button, ResizableLayout } from "@dune/ui";
import { ArrowLeft, X } from "lucide-react";
import React from "react";
import {
	useCurrentPanel,
	usePanelActions,
	usePanelHistory,
} from "../../stores/panel.store";

const PanelProvider: React.FC = () => {
	const currentPanel = useCurrentPanel();
	const { clearPanel, goBack } = usePanelActions();
	const panelHistory = usePanelHistory();
	const hasHistory = panelHistory.length > 0;

	if (!currentPanel) {
		return null;
	}

	const { component, meta } = currentPanel;
	const handleClose = () => {
		if (meta?.onClose) {
			meta.onClose();
		} else {
			clearPanel();
		}
	};

	return (
		<>
			<ResizableLayout.PanelHeader className="p-2 px-4">
				<div className="flex items-center justify-between w-full">
					<div className="flex items-center gap-2">
						{hasHistory && (
							<Button
								variant="ghost"
								size="icon"
								onClick={goBack}
								title="Retour"
								className="h-6 w-6"
							>
								<ArrowLeft size={14} />
							</Button>
						)}
						{meta?.title && (
							<h2 className="font-semibold text-lg">{meta.title}</h2>
						)}
					</div>
					<div className="flex items-center gap-2">
						{meta?.actions}
						<Button
							variant="ghost"
							size="icon"
							onClick={handleClose}
							title="Fermer"
							className="h-6 w-6"
						>
							<X size={14} />
						</Button>
					</div>
				</div>
			</ResizableLayout.PanelHeader>
			<ResizableLayout.PanelContent>{component}</ResizableLayout.PanelContent>
		</>
	);
};

export default PanelProvider;
